import React, { memo } from 'react'

import { Icon, Play } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { iconSizeMedium } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import pauseIcon from 'images/three_d_studio/animation_player/pause.svg'

import ProgressTrack from './Components/ProgressTrack/ProgressTrack'
import { useAnimationPlayback } from './useAnimationPlayback'
import { formatPlaybackTime } from './Utils/formatPlaybackTime'

function AnimationPlayer() {
  const t = useTranslation()
  const { hasClips, isPlaying, currentTime, duration, togglePlay, seek } = useAnimationPlayback()

  // A rigged model without clips (or one still loading) has nothing to drive,
  // so the bar stays out of the viewer rather than showing a dead 0:00 track.
  if (!hasClips) {
    return null
  }

  const currentLabel = formatPlaybackTime(currentTime, duration)
  const durationLabel = formatPlaybackTime(duration, duration)

  return (
    <div className="animation-player">
      <div className="animation-player__content">
        <button
          type="button"
          className="animation-player__toggle"
          aria-label={isPlaying ? t('viewer.animationPlayer.pause') : t('viewer.animationPlayer.play')}
          onClick={togglePlay}
        >
          {isPlaying ? (
            <img className="animation-player__toggle-icon" src={pauseIcon} alt="" aria-hidden="true" />
          ) : (
            <Icon notSpaced svgComponent={Play} color="dark" size={iconSizeMedium} />
          )}
        </button>
        <ProgressTrack
          currentTime={currentTime}
          duration={duration}
          bufferedSeconds={duration}
          label={t('viewer.animationPlayer.timeline')}
          valueText={t('viewer.animationPlayer.progress', { current: currentLabel, total: durationLabel })}
          onSeek={seek}
        />
      </div>
      <div className="animation-player__timestamps cgt-caption-semibold">
        <span>{currentLabel}</span>
        <span>/</span>
        <span>{durationLabel}</span>
      </div>
    </div>
  )
}

export default memo(AnimationPlayer)
